import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { useState } from 'react';
import NewAddressModal from '../../../UserAccount/AccountAddresses/NewAddressModal';
import { StyledTextButton } from '../../../../styles';
import { FiPlus } from 'react-icons/fi';

const DeliveryAtAddress = ({
  address,
  onAddressChange,
  role,
  clientAddresses,
}) => {
  const [isAddAddressOpen, setIsAddAddressOpen] = useState(false);

  return (
    <>
      <FormControl
        margin='normal'
        sx={{ marginY: 2 }}
      >
        <InputLabel>Selecione a morada</InputLabel>

        <Select
          label='Selecione a morada'
          value={address.street}
          onChange={onAddressChange}
        >
          {clientAddresses.map(({ street }, index) => (
            <MenuItem
              key={`${street}-${index}`}
              index={index}
              value={street}
            >
              {street}
            </MenuItem>
          ))}
        </Select>

        {role !== 'seller' && (
          <StyledTextButton
            variant='contained'
            color='secondary'
            value='addNewAddress'
            title='Adicionar morada'
            onClick={() => setIsAddAddressOpen(true)}
            endIcon={<FiPlus size={14} />}
            sx={{
              alignSelf: ' flex-start',
              marginTop: 2,
            }}
          >
            Adicionar morada
          </StyledTextButton>
        )}
      </FormControl>

      <NewAddressModal
        isOpen={isAddAddressOpen}
        setIsOpen={setIsAddAddressOpen}
      />
    </>
  );
};

export default DeliveryAtAddress;
